import { useContext } from 'react'
import { PassContext } from '../../pass-context.js'

import Card from './components/card.jsx'
import Logo from './components/logo.jsx'
import AppLinkLogo from './components/app-link-logo.jsx'
import HeaderFields from './components/header-fields.jsx'
import Barcode from './components/barcode.jsx'
import ThumbnailImage from './components/thumbnail-image.jsx'
import Fields from './components/fields.jsx'

const Generic = ({ passFieldCount }) => {

  const { template } = useContext(PassContext)

  // vary primary field with if thumbnail is used
  const primaryFieldWidth = template.meta.images?.thumbnail ? 220 : 300
  const primaryFieldHeight = 80

  return (
    <div className="relative">
      <Card>
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <Fields maxFields={1} fieldType="primary" fieldsOverallWidth={primaryFieldWidth} fieldsOverallHeight={primaryFieldHeight} />
        <ThumbnailImage />
        <Fields maxFields={passFieldCount.secondary} fieldType="secondary" />
        <Fields maxFields={passFieldCount.auxiliary} fieldType="auxiliary" />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>
  )
}

export default Generic

const Clipmap = () => (
  <svg className='apple-svg-clip absolute top-0'>
    <defs>
      <clipPath id="apple_clip_path">
        <rect id="clip" width="375" height="523" rx="10" ry="10" />
      </clipPath>
    </defs>
    <use href="#clip" />
  </svg>
)